import { MessageBar, MessageBarType, PrimaryButton } from "@fluentui/react";
import { FormikHelpers } from "formik";
import { memo } from "react";

import { SubmitOwnershipTransferFieldsValues } from "../fields/ownership-transfer-fields.interface";

import { CustomDrawer } from "@/components/Shared/CustomDrawer";
import FormBuilder from "@/core/libs/form-builder";

interface EditComplementaryDocumentsProps {
  isOpen: boolean;
  onClose: () => void;
  fields: any;
  validationSchema: unknown;
  onSubmit: (
    values: SubmitOwnershipTransferFieldsValues,
    formikHelpers: FormikHelpers<SubmitOwnershipTransferFieldsValues>
  ) => void | Promise<void>;
  errorMessage?: string;
}

const EditComplementaryDocuments = memo(
  ({
    isOpen,
    onClose,
    fields,
    validationSchema,
    onSubmit,
    errorMessage
  }: EditComplementaryDocumentsProps) => {
    return (
      <CustomDrawer
        isOpen={isOpen}
        onCloseDrawer={onClose}
        action="Editar"
        module="Documentos Complementares"
      >
        <FormBuilder
          fields={fields}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {errorMessage && (
            <MessageBar messageBarType={MessageBarType.error} isMultiline>
              {errorMessage}
            </MessageBar>
          )}

          <PrimaryButton type="submit" style={{ width: "200px" }}>
            Salvar informações
          </PrimaryButton>
        </FormBuilder>
      </CustomDrawer>
    );
  }
);

EditComplementaryDocuments.displayName = "EditComplementaryDocuments";

export default EditComplementaryDocuments;
